export class Feedback {
  formItem:string;
  formItemName:string;
  percentile:number;
  percentileTitle:string;
  example:string;
  exampleTruncated:string;
  skill:string;
  assignment:string;
  message:string;
  messageTruncated: string; // for listing
}
